<div class="map" #map [ngClass]="circleMap() ? 'circle' : 'square'">
    @if (store().locationImage.id || store().locationImage.image) {
        <img class="map-image" alt="" [woa-image-cache]="store().locationImage">
    } @else if (store().latitude && store().longitude) {
        <!--suppress AngularNgOptimizedImage -->
        <img class="map-image" alt="" [src]="mapImageSrc()"/>
    }
</div>
